import { useState } from 'react';
import { useMountEffect } from '@client/hooks/utils.hooks';
import { getImageThumbUrl } from '@sda/utils/image';
import type { ImageLoaderProps } from '../interfaces';

export const ImageLoader: React.FC<ImageLoaderProps> = ({
  path, updatedAt, sizeCallback, children,
}) => {
  const [src, setSrc] = useState(() => getImageThumbUrl(path, updatedAt));

  useMountEffect(() => {
    const img = new Image();
    img.src = sizeCallback(path, updatedAt);

    img.onload = () => {
      setSrc(img.src);
    };
  });

  return children(src);
};
